// src/components/tiptap/TiptapEditor.js

import React, { useRef } from 'react';
import { useEditor, EditorContent } from '@tiptap/react';
import StarterKit from '@tiptap/starter-kit';
import Image from '@tiptap/extension-image';
import Link from '@tiptap/extension-link';
import MenuBar from './MenuBar'; // Importe o MenuBar

export default function TiptapEditor({ content, onChange, minHeight = '300px' }) {
    const editor = useEditor({
        extensions: [
            StarterKit,
            Image.configure({
                allowBase64: true,
            }),
            Link.configure({
                openOnClick: true,
                autolink: true,
                defaultProtocol: 'https',
                HTMLAttributes: {
                    class: 'text-cyan-400 hover:text-cyan-300 underline cursor-pointer',
                    rel: 'noopener noreferrer',
                    target: '_blank',
                },
            }),
        ],
        content: content,
        onUpdate: ({ editor }) => {
            onChange(editor.getHTML());
        },
        editorProps: {
            attributes: {
                class: `prose prose-invert max-w-none p-4 bg-slate-900 rounded-b-md focus:outline-none text-white`,
                style: `min-height: ${minHeight};`,
            },
            handlePaste: (view, event, slice) => {
                const files = event.clipboardData?.files;
                if (!files || files.length === 0) {
                    return false;
                }
                const imageFiles = Array.from(files).filter(file => file.type.startsWith('image/'));
                if (imageFiles.length === 0) {
                    return false;
                }
                event.preventDefault();
                imageFiles.forEach(file => {
                    imageToBase64(file);
                });
                return true;
            },
        },
    });

    const imageToBase64 = (file) => {
        if (!file) return;

        if (file.size > 750000) { 
            alert("Aviso: Imagens grandes podem deixar o artigo lento ou exceder o limite de 1MB. Considere otimizar a imagem antes de enviar.");
        }

        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
            if (editor) {
                editor.chain().focus().setImage({ src: reader.result }).run();
            }
        };
        reader.onerror = (error) => {
            console.error("Erro ao converter imagem para Base64:", error);
            alert("Falha ao processar a imagem.");
        };
    };

    return (
        <div className="border border-slate-600 rounded-md bg-slate-900 text-white">
            <MenuBar editor={editor} onImageUpload={imageToBase64} />
            <EditorContent editor={editor} />
        </div>
    );
}
